import { Grid } from "@mui/material";
import Field from "components/Field";
import FieldRichText from "components/FieldRichText";
import { useIntl } from "react-intl";
import { MetaValueFieldProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";
import { AttributeMetaValues } from "types/common-types";

const labelKeys: Partial<Record<string, string>> = {
  [AttributeMetaValues.Description]: "descriptionLabel",
  [AttributeMetaValues.Directions]: "locationFormDirectionsLabel",
};

export function RichTextField({
  metaValueName,
  index,
  attributeMetaValues,
}: MetaValueFieldProps) {
  const { formatMessage: t } = useIntl();

  const existingValue = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  const labelKey = labelKeys[metaValueName] ?? "descriptionLabel";

  return (
    <>
      <Field
        name={`attributeMetaValues[${index}].name`}
        initialValue={metaValueName}
      >
        {() => null}
      </Field>
      <Field
        name={`attributeMetaValues[${index}].value`}
        initialValue={existingValue ?? ""}
      >
        {({ input, meta }) => (
          <Grid item xs={12}>
            <FieldRichText
              input={input}
              meta={meta}
              label={t({ id: labelKey })}
              init={{
                height: 280,
              }}
            />
          </Grid>
        )}
      </Field>
    </>
  );
}
